import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: start;
  margin: 0 1rem 0 0;
`;

export const ImgWrapper = styled.div`
  padding: 0 0 0 5px;
  display: flex;
  align-items: center;
  justify-content: centrer;
  height: 100%;
`;
